module.exports = __webpack_public_path__ + "static/img/header.3cfdb124.png";